import { Component, OnInit, LOCALE_ID, Inject } from '@angular/core';
import { IOved } from 'app/admin/interface/ioved.interface';
import { ConfirmDialogComponent } from 'app/shared/dialog/confirm-dialog/confirm-dialog.component';
import { MatDialogConfig, MatDialog } from '@angular/material';
import { IPrefixMobile } from 'app/admin/model/kod-mobile-prefix';
import { Validators, FormBuilder, FormArray, FormGroup } from '@angular/forms';
import { IntlService } from '@progress/kendo-angular-intl';
import { AdminService } from 'app/admin/admin.service';
import { UserMessagesService } from 'app/shared/user-messages/user-messages.service';
import { Router } from '@angular/router';
import { ConfirmService } from 'app/shared/dialog/confirm.service';
import { ResultOfOperation } from 'app/shared/model/result-of-operation.model';
import { Location } from '@angular/common';
import { IHerkevHazmanaChangeNofesh } from 'app/admin/model/herkev-hazmana-change-nofesh';
import { IReservationChangeNofshon } from 'app/admin/interface/ireservationChangeNofesh.interface';
import { NofshonNirshamimChangeNofesh } from 'app/admin/interface/nofshon-nirhsamim-change-nofesh';
import { IChangeReservation } from 'app/admin/interface/changeReservation';
import { IHerkevHazmana } from 'app/nofshonim-chul/model/herkev-hazmana';
import { SpinnerService } from 'app/shared/spinner/spinner.service';
import { NofeshService } from 'app/nofesh/nofesh.service';
import { NofshonimService } from 'app/nofshonim-chul/nofshonim.service';
import { NilvimToRemove } from 'app/admin/interface/nilvim-to-remove';
import { INirsham } from 'app/nofesh/model/nirsham';
import { CustomValidators } from 'ng2-validation';
import { Nilve } from 'app/admin/interface/nilve';
import { INofesh } from 'app/nofesh/model/nofesh';



interface IKeyValue {
  key: number;
  value: string;

}
interface IKeyValues {
  key: number;
  value: string;
  secondValue: string;
}


@Component({
  selector: 'app-add-nilve',
  templateUrl: './add-nilve.component.html',
  styleUrls: ['./add-nilve.component.css']
})
export class AddNilveComponent implements OnInit {
  choosedTitleForChange: number;
  showAvailableRooms: boolean = false;
  availableRoomsStandard: number;
  availableRoomsHamtana: number;
  is_updated: boolean = false;
  is_Oved_Exists: boolean = false;
  ms_zehut_valid: boolean = true;
  is_oved_searched: boolean = false;
  isOvedMazminFound: boolean = false;
  nofshonimReservations: IReservationChangeNofshon[] = [];
  selectedReservation: IReservationChangeNofshon;
  selectedReservationForChange: NofshonNirshamimChangeNofesh;
  changeReservationNofshon: IChangeReservation;
  nofesh_title: string = "";
  maxAmitim: number;
  maxNilvim: number;
  quotationSubmitted: boolean = false;
  isValidHerkevHazmana: boolean = true;
  nofesh_price: number;
  ms_chadarim: number;
  return_message: string;
  quotation_success: boolean = true;
  is_hamtana: boolean;
  nofeshId: number;
  currentNumberOfRooms: number;
  CurrentHerkevHazmana: IHerkevHazmana = {
    nofesh_id: 0,
    ms_amit: 0,
    ms_nilve: 0,
    ms_yeladim: 0,
    ms_tinokot: 0
  };
  isHamtanaForNewNofesh: boolean;
  isNilvimSubmitted:boolean = false;
  checkedNilvim: number[] = [];
  nilvimToRemove: NilvimToRemove =
  {
    id_nofesh :0,
    nilvim : []
  }

  users = [
    { id: 1001, label: 'Roma', lat: 42, lng: 12 },
    { id: 1002, label: 'Copenaghen', lat: 56, lng: 14},
    { id: 1003, label: 'Gibuti', lat: 11, lng: 44}
  ];

  get amitim() { return this.herkevHazmana.get("ms_amit"); };
  get nilvim() { return this.herkevHazmana.get("ms_nilve"); };
  get yeladim() { return this.herkevHazmana.get("ms_yeladim"); };
  get tinokot() { return this.herkevHazmana.get("ms_tinokot"); }

  get ms_zehut_mazmin_error() { return this.nofesh.get('ms_zehut_mazmin'); }
  get ms_zehut_nilve() { return this.nofesh.get('ms_zehut_nilve'); }

  addedNilvim: FormGroup = this.fb.group({
    nilvim: this.fb.array([])
  });

  get getAddedNilvim() { return <FormArray>this.addedNilvim.get("nilvim") };


  constructor(private fb: FormBuilder,
    private _adminService: AdminService,
    private router: Router,
    private userMessages: UserMessagesService,
    private spinnerService: SpinnerService,
    private dialog: MatDialog,
    private confirmService: ConfirmService,
    private _nofeshService: NofeshService,
    private _userMessagesService: UserMessagesService,
    private _nofshonimService: NofshonimService) { }

  ngOnInit() {
   console.log(this.addedNilvim, this.addedNilvim.get("nilvim"), this.getAddedNilvim);
  }

  herkevHazmana = this.fb.group({
    ms_amit: [1, Validators.compose([Validators.required, Validators.min(1), Validators.max(this.maxAmitim)])],
    ms_nilve: [0, Validators.compose([Validators.required, Validators.max(this.maxNilvim)])],
    ms_yeladim: [0, Validators.compose([Validators.required])],
    ms_tinokot: [0, Validators.compose([Validators.required])]


  });
  
  // empty form group array for all nilvim
  // on addNilve - add form to array
  // in template, pass form array to nirshamim element

 
  nilvimToSubmit: INirsham[] = [];

  nofashim: INofesh[] = [];
  nofeshNirsham: INofesh;

  nofesh = this.fb.group({
    //main mazmin
    isCheckedNilve: false,
    nofeshTitle: [0],
    ms_zehut_mazmin: ['', Validators.compose([Validators.pattern("^[0-9]*$"), Validators.required])],
    ms_zehut_nilve: ['', Validators.compose([Validators.pattern("^[0-9]*$"), Validators.required])],
    nofeshTitleForChange: [0],
    tr_leida: [''],
    shem_prati: [''],
    shem_mishpacha: [''],
    ms_zehut: [''],
    phone: [''],
    nofesh_title: [''],
    nofesh_from: [''],
    nofesh_to: [''],
    is_hamtana: [''],
    ofen_tashlum: ["", Validators.required]
  })
  allNofshonimTitles: IKeyValue[] = [
    { key: 0, value: "בחר" }
  ]

  nofeshTitles: IKeyValue[] = [
    { key: 0, value: "בחר" }
  ];

  displayNofesh() {

 
    this._userMessagesService.clearAll();
    this.selectedReservation = this.nofshonimReservations.find(reservation => reservation.nirshamim[0].id_nofesh == this.nofesh.value.nofeshTitle);
    this.getAllNofshonim();
    

  }

  resetNofeshTitles() {
    this.nofeshTitles = [
      { key: 0, value: "בחר" }
    ];
    this.nofesh.value.nofeshTitle = 0;
  }
  resetNofeshTitlesAndTable() {
    this.nofshonimReservations = [];
    this.selectedReservation = undefined;
    this.nofeshTitles = [
      { key: 0, value: "בחר" }
    ];
    this.nofesh.value.nofeshTitle = 0;

  }
  searchNofshonimhForNirshamim() {

    this.userMessages.clearAll();
    this.resetNofeshTitlesAndTable();

    this.validateOvedmsZehut(this.nofesh.value.ms_zehut_mazmin);
    if (this.ms_zehut_valid) {
      this.spinnerService.showSpinner();
      this._adminService.GetNofeshAllNirshamimChangeNofesh(this.nofesh.value.ms_zehut_mazmin).subscribe(response => {

        if (response.isSuccess) {
          this.spinnerService.hideSpinner();
          this.nofshonimReservations = response.data as IReservationChangeNofshon[];
          this.nofesh.patchValue({ nofesh_title: this.nofshonimReservations[0].nirshamim[0].nofesh_title });
          this.nofesh.patchValue({ nofesh_from: this.nofshonimReservations[0].nirshamim[0].nofesh_from });
          this.nofesh.patchValue({ nofesh_to: this.nofshonimReservations[0].nirshamim[0].nofesh_to });

          //Object.assign(this.nofshonimReservationsFiltered, this.nofshonimReservation);
          // this.nofshonimReservations.forEach(reservation => {
          //   this.nofeshTitles.push({key: reservation.nirshamim[0].id_nofesh, value:reservation.nirshamim[0].nofesh_title});
          // });
          this.nofeshTitles = this._adminService.getNofeshTitles(this.nofshonimReservations);

        }
        else {
          this.spinnerService.hideSpinner();
          this.is_oved_searched = true;
        }
      })
    }
  }
  
  validateOvedmsZehut(ms_zehut) {
    let valid_zehut = this.validatemsZehut(ms_zehut);
    if (valid_zehut) {
      this.ms_zehut_valid = true;
    }
    else {
      this.ms_zehut_valid = false;
      this.nofesh.patchValue({ ms_zehut: "" });
      return;
    }
  }
  validatemsZehut(value) {

    if (value.length == 0)
      return false;
    console.log(value.length);


    var result = true;
    var first8 = null;
    var cifratBikoret = null;
    try {
      if (value.length == 10)
        first8 = value.substring(0, 9);
      else {
        if (value.length == 9)
          first8 = "0" + value.substring(0, 8);
        else
          first8 = "00" + value.substring(0, 8);
      }
      cifratBikoret = value.substring(value.length - 1);
      var checkDigits = 0 * 1;
      var temp = 0;
      var i = 0;

      for (i = 1; i <= 9; i++) {
        temp = first8.charAt(i - 1);
        checkDigits = temp * 1 + checkDigits * 1;
        if ((i % 2) == 1) {
          checkDigits = temp * 1 + checkDigits * 1;
          if (temp > 4)
            checkDigits = checkDigits * 1 - 9;
        }
      }
      checkDigits = (10 - checkDigits % 10) % 10;
      result = (checkDigits * 1 == cifratBikoret * 1);
    }
    catch (e) { result = false; }
    if (value == "0")
      result = false;
    return result;
  }
  onMsZehutSearchChange(value: string) {
    this.is_oved_searched = false;
  }
  getAllNofshonim() {
    this._nofeshService.getAllNofashim().subscribe(res => {
      if (res.isSuccess) {
        let nofshonim = res.data;
        //get all nofshonim except the current one in reservatiuon.
        nofshonim = nofshonim.filter(nofshonim => nofshonim.nofeshType == 4 && nofshonim.k_pail == 1 && nofshonim.id_nofesh != this.nofesh.value.nofeshTitle)
        this.allNofshonimTitles = this._adminService.getAllNofshonimTitles(nofshonim);
      }
      else {
        this._userMessagesService.setErrorMessage("לא קיימים נופשונים - אנא פנה למנהל המערכת")
      }
    })

  }
  currentNofshonForChange() {

    let selectedReservationForChange = this.allNofshonimTitles.find(reservation => reservation.key == this.nofesh.value.nofeshTitleForChange);
    this.nofeshId = this.nofesh.value.nofeshTitleForChange;



  }
  getNofshonQuotationOnly() {
    // Reset return message and quotation success if an error message was shown.
    this.return_message = "";
    this.quotation_success = true;

    let herkevHazmana: IHerkevHazmana = {
      nofesh_id: this.nofeshId, //this is the NEW nofesh ID while the other details as follow has been copied from the prveious herkev hazmana.
      ms_amit: this.CurrentHerkevHazmana.ms_amit,//this.amitim.value,
      ms_nilve: this.CurrentHerkevHazmana.ms_nilve,//this.nilvim.value,
      ms_yeladim: this.CurrentHerkevHazmana.ms_yeladim, //this.yeladim.value,
      ms_tinokot: this.CurrentHerkevHazmana.ms_tinokot//this.tinokot.value
    };

    this._nofshonimService.getNofshonQuotationOnly(herkevHazmana).subscribe(
      res => {
        ;
        this.quotationSubmitted = true;
        if (!res.status) {
          this.quotation_success = false;
          this.return_message = res.returnMessage;
          this.quotationSubmitted = false;
        }
        else {
          this.quotation_success = true;
          this.nofesh_price = res.mechir_le_nofesh;
          this.ms_chadarim = res.ms_chadarim;
          this.is_hamtana = res.is_hamtana;

          // init timer
          /*
                     this.resetCounter();
                     this.minutesLeft--;
                     this.authCodeTimer = timer(0, 1000).subscribe(time => this.authCodeTimerHandler(time));
                     */
        }
      },
      error => {
        this.quotation_success = false;
        this.return_message = "לא נמצאה התאמה לבקשה אנא נסה שנית";
        this.quotationSubmitted = false;
      });
  }
  changeNofesh() {
    //TODO: check if new nofesh has roome? or no need? -- MATAN

    let herkevHazmanaChangeNofesh: IHerkevHazmanaChangeNofesh = {

      ms_zehut_mazmin: this.nofesh.value.ms_zehut_mazmin,
      id_nofesh: this.nofesh.value.nofeshTitle,
      new_id_nofesh: this.nofesh.value.nofeshTitleForChange,
      ofen_tashlum: this.nofesh.value.ofen_tashlum,
      schum: this.nofesh_price,
      isHamtana: this.isHamtanaForNewNofesh
    };

    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = true;

    dialogConfig.data = { title: "החלפת נופש ", text: "האם אתה בטוח שהינך רוצה לשנות את הנופש?" }
    let dialogRef = this.dialog.open(ConfirmDialogComponent, dialogConfig);
    let result: ResultOfOperation<object>;
    let confirmSubscription = this.confirmService.confirm$.subscribe((confirm: boolean) => {

      if (confirm) {
        debugger;
        this.spinnerService.showSpinner();
        this._adminService.changeNofesh(herkevHazmanaChangeNofesh).subscribe(res => {
          result = res;

          confirmSubscription.unsubscribe();
          dialogRef.close();
        })
      }
      else {
        dialogRef.close();
      }
    })
    debugger;
    dialogRef.afterClosed().subscribe(_ => {
      if (result && result.isSuccess) {
        this.userMessages.setSuccessMessage("החלפת נופשון בוצעה בהצלחה");
        this.spinnerService.hideSpinner();
        this.resetNofeshTitlesAndTable();
      }
      else if (result && !result.isSuccess) {
        this.userMessages.setErrorMessage("בעיה בהחלפת נופשון");
        this.spinnerService.hideSpinner();
      }
      else {
        this.router.navigateByUrl("admin/nofesh-admin/change-nofesh");
        //this.userMessage.setErrorMessage("בעיה במחיקת נופשון, אנא נסה שוב מאוחר");
      }
    });

  }

  toggleNilve(nilveChkbx)
  {
    if(nilveChkbx.checked)
    {
      this.checkedNilvim.push(Number(nilveChkbx.id));
    }
    else
    {
      let index: number = this.checkedNilvim.indexOf(Number(nilveChkbx.id));
      this.checkedNilvim.splice(index, 1);
    }
  }
  removeNilvim() {

 
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = true;

    dialogConfig.data = { title: "החלפת נופש ", text: "האם אתה בטוח שהינך רוצה להסיר את הנלווים?" }
    let dialogRef = this.dialog.open(ConfirmDialogComponent, dialogConfig);
    let result: ResultOfOperation<object>;
    let confirmSubscription = this.confirmService.confirm$.subscribe((confirm: boolean) => {
     
      if(this.checkedNilvim.length==0)
      {
        dialogRef.close();
        this.userMessages.setErrorMessage("לא נבחרו נלווים");
      }
      else
      {
        if (confirm) {
          
          for(let i =0;i<this.checkedNilvim.length;i++)
          {
            this.selectedReservation.nirshamim.forEach(element => {
              if(this.checkedNilvim[0]==element.ms_zehut)
              {
                let nirshamIndex = this.selectedReservation.nirshamim.indexOf(element)
                this.selectedReservation.nirshamim.splice(nirshamIndex,1)
              }
            }); 
          }
          
           this.spinnerService.showSpinner();
           this.nilvimToRemove = {
             id_nofesh : this.selectedReservation.nirshamim[0].id_nofesh,
             nilvim : this.checkedNilvim
           }
           debugger;
           this._adminService.removeNilvim(this.nilvimToRemove).subscribe(res => {
             result = res;
  
             confirmSubscription.unsubscribe();
             dialogRef.close();
           })
        }
        else {
          dialogRef.close();
        }
      }
    })
    dialogRef.afterClosed().subscribe(_ => {
      if (result && result.isSuccess) {
        this.userMessages.setSuccessMessage("החלפת נופשון בוצעה בהצלחה");
        this.spinnerService.hideSpinner();
        this.resetNofeshTitlesAndTable();
      }
      else if (result && !result.isSuccess) {
        this.userMessages.setErrorMessage("בעיה בהחלפת נופשון");
        this.spinnerService.hideSpinner();
      }
    });

  }

  addNilve(): void
  {
    let nilve: FormGroup =  this.fb.group({
      ms_zehut: ['', Validators.required],
      tr_leida: ['', Validators.required],
      shem_prati: ['', Validators.required],
      shem_mishpacha: ['', Validators.required],
      ms_darkon: ['', Validators.required],
      tr_tokef_darkon: ['', Validators.required],
      shem_prati_loazi: ['', Validators.required],
      shem_mishpacha_loazi: ['', Validators.required],
      phone: ['', Validators.required],
      gender: ['', Validators.required],
      email: ['', [CustomValidators.email]],
      llo_nitsul_zakaut: [0]
    });

    (<FormArray>this.addedNilvim.controls["nilvim"]).push(nilve);

    if(this.nofashim.length == 0)
    {
      this._nofeshService.getAllNofashim().subscribe((response: ResultOfOperation<INofesh[]>) => {
        if(response.isSuccess && response.data != null)
        {
          this.nofashim = response.data;
          this.nofeshNirsham = this.nofashim.find(nofesh=>nofesh.id_nofesh==this.nofshonimReservations[0].nirshamim[0].id_nofesh);
        }
      });
    }
    

  }
  removeNilve(): void
  {
    if( (<FormArray>this.addedNilvim.controls["nilvim"]).length>0)
    {
      (<FormArray>this.addedNilvim.controls["nilvim"]).removeAt((<FormArray>this.addedNilvim.controls["nilvim"]).length-1);
    }
   
  }

  addNilvim()
  {
    let nilvim: Nilve[] = [];
    
    for(let i=0;i<(<FormArray>this.addedNilvim.controls.nilvim).controls.length;i++)
    {
      debugger;

      //console.log("nilvim",(<FormArray>this.addedNilvim.controls.nilvim).controls[i]);
      let nilve: Nilve = new Nilve();
      nilve.email = (<FormArray>this.addedNilvim.controls.nilvim).controls[i].value.email,
      nilve.gender = (<FormArray>this.addedNilvim.controls.nilvim).controls[i].value.gender
      nilve.llo_nitsul_zakaut = (<FormArray>this.addedNilvim.controls.nilvim).controls[i].value.llo_nitsul_zakaut;
      nilve.ms_darkon = (<FormArray>this.addedNilvim.controls.nilvim).controls[i].value.ms_darkon;
      nilve.ms_zehut = (<FormArray>this.addedNilvim.controls.nilvim).controls[i].value.ms_zehut;
      nilve.phone = (<FormArray>this.addedNilvim.controls.nilvim).controls[i].value.phone;
      nilve.shem_mishpacha = (<FormArray>this.addedNilvim.controls.nilvim).controls[i].value.shem_mishpacha;
      nilve.shem_mishpacha_loazi = (<FormArray>this.addedNilvim.controls.nilvim).controls[i].value.shem_mishpacha_loazi;
      nilve.shem_prati = (<FormArray>this.addedNilvim.controls.nilvim).controls[i].value.shem_prati;
      nilve.shem_prati_loazi = (<FormArray>this.addedNilvim.controls.nilvim).controls[i].value.shem_prati_loazi;
      nilve.tr_leida = (<FormArray>this.addedNilvim.controls.nilvim).controls[i].value.tr_leida;
      nilve.tr_tokef_darkon = (<FormArray>this.addedNilvim.controls.nilvim).controls[i].value.tr_tokef_darkon;
      
      nilve.id_nofesh = this.nofshonimReservations[0].nirshamim[0].id_nofesh;
      nilve.ms_zehut_mazmin = this.nofesh.value.ms_zehut_mazmin;
      nilvim.push(nilve);
    }

    //console.log(nilvim);
    this._adminService.addNilvimNofesh(nilvim).subscribe(result=>{
      if(result)
      {
        this._userMessagesService.setSuccessMessage("נלווים הוספו בהצלחה ");
        this.isNilvimSubmitted = true;
        sessionStorage.setItem('ms_zehut_mazmin',this.nofesh.value.ms_zehut_mazmin);
      }
      else
      {
        this._userMessagesService.setErrorMessage("בעיה בהוספת נלווים");
      }
    })
  }
}
